// Network constants
export const REQUEST_UNSENT = 'UNSENT';
export const REQUEST_PENDING = 'PENDING';
export const REQUEST_COMPLETE = 'COMPLETE';
export const REQUEST_FAILED = 'FAILED';

export const KNOWN_DEVICES_FETCH_DATA = 'KNOWN_DEVICES_FETCH_DATA';
export const EDIT_DEVICE_DATA = 'EDIT_DEVICE_DATA';
export const DEVICES_CLEAR_DATA = 'DEVICES_CLEAR_DATA';
export const CREATE_NEW_DEVICE_DATA = 'CREATE_NEW_DEVICE_DATA';
export const DELETE_DEVICE_DATA = 'DELETE_DEVICE_DATA';
export const CLEAR_DEVICE_ERRORS = 'CLEAR_DEVICE_ERRORS';

export const SUBMIT_DEVICE_DATA = 'SUBMIT_DEVICE_DATA';
export const REINITIATE_DEVICE = 'REINITIATE_DEVICE';

export const SAVE_DEVICES_TO_STORE = 'SAVE_DEVICES_TO_STORE';

export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_VERSION = 'GET_VERSION';

export const ERROR_ALERT_PUSH = 'ERROR_ALERT_PUSH';
export const ERROR_LIST_CLEAR = 'ERROR_LIST_CLEAR';
export const INFO_ALERT_PUSH = 'INFO_ALERT_PUSH';
export const INFO_LIST_CLEAR = 'INFO_LIST_CLEAR';



// WEBPACK FOOTER //
// ./src/constant/reducerConstants.js